module.exports = __webpack_public_path__ + "img/directions.3dbba6cd.svg";